import { Box, Typography } from '@mui/material';
import React from 'react'
import { dataConstants } from '../../../../constants';
import { getRandomStr, getTabData } from '../../../../helpers';
import ChartItem from '../../../_common/Skeleton/chart';
import dynamic from 'next/dynamic';
import CommitRoundedIcon from '@mui/icons-material/CommitRounded';
import { getChartSeriesColor } from '../../../../utils';
import DotLine from '../../../../static/images/component/dotline.svg';

const D3Chart = dynamic(() => import('../../../_common/D3Chart'),
  { loading: () => <ChartItem /> })

const { ECO_SECTION_CODES } = dataConstants || {};

function ComparedToDay({ data, getChartData, yData, themes, yieldYest, getYieldTbl }) {

  // const yieldYest = data && data.find(d => d.section_code === ECO_SECTION_CODES.YIELD_YEST_CHART) ? data.find(d => d.section_code === ECO_SECTION_CODES.YIELD_YEST_CHART) : undefined;
  const yieldYestChart = yieldYest && yieldYest.tabData ? getChartData(yieldYest.tabData, getTabData(yData, yieldYest, ECO_SECTION_CODES.YIELD_DATA), 'sequenceData') : undefined;

  const yieldTbl = getYieldTbl(yieldYestChart, true);

  return (
    <>
      {yieldYest && yieldYestChart !== undefined &&
        <Box component="div" className="col-md-6">
          <Box className="section">
            <Typography component="h4" className="option-title" sx={{ mr: 'auto', fontWeight: 600 }} >
              {yieldYest.section_name}
            </Typography>
          </Box>
          <Box component="div" className="option-content eco-chart" sx={{ py: 2, pr: 3, minHeight: { md: '20.3rem', xs: '13.3rem' } }}>
            <D3Chart
              showChart={true}
              //noHeader
              // maxHeight={chartProps.maxHeight}
              scale={1}
              // onClick={code => handleClick(code)}
              chart={{ ...yieldYestChart, id: yieldYest.section_code }}
              // userName={`@${chart.code.split('@')[1]}`}
              themes={themes}
              type={dataConstants.CHART_STATE.VIEW}
              // axisTextMargin={chartProps.axisTextMargin}
              //chartMargin={{left: 40, bottom: 48 }}
              //axisTextMargin={{ y: 96 }}
              // wrapperClass="StockCardImage"
              //showLegend={false}
              showCrosshair
            />
          </Box>
          <Box component="div" sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
            {yieldYestChart?.series.map((d, i) => {
              return (
                d?.legend?.label && d?.legend?.label !== '' &&
                <Box key={getRandomStr(4)} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2, mr: 1.5, '& .dotline': { mr: .7, mb: .6, width: '1em !important', fontSize: '1.3rem !important', fill: getChartSeriesColor(d, yieldYestChart?.currTheme.pallete[i]) } }}>
                  {d?.setting?.line?.dashArray ? <DotLine className="dotline" /> : <CommitRoundedIcon sx={{ mr: .7, width: '1em !important', fontSize: '1.1rem !important', color: getChartSeriesColor(d, yieldYestChart?.currTheme.pallete[i]) }} />}
                  <Typography variant="p" sx={{ fontSize: '.67rem', fontWeight: 600 }}>{d.legend.label}</Typography>
                </Box>
              );
            })}
          </Box>
        </Box>
      }
      {yieldTbl !== undefined &&
        <Box component="div" className="yield-tbl">
          {yieldTbl}
        </Box>}
    </>
  )
}

export default ComparedToDay
